export default __webpack_public_path__ + "static/mindme-featured-image-3de00e56fb08b754b2b8c67f061f7ed8.jpg";